export default {
  getLiveGoodsMes(data) {
    return this.http('Bingo', 'get', '/api/v1/streams', data);
  }
};
